import React from 'react';

/**
 * Componente para manejar metadatos SEO de forma centralizada
 * Uso: <SEOHead title="..." description="..." />
 */
const SEOHead = ({ 
  title = 'Sol y Luna - Tienda Online de Productos Exclusivos',
  description = 'Tienda online de productos exclusivos de sol y luna. Compra con seguridad en Argentina.',
  keywords = 'sol y luna, tienda online, comprar, productos',
  canonical = 'https://my-store-syl.web.app/',
  ogImage = 'https://my-store-syl.web.app/logo192.png',
  ogType = 'website',
  author = 'Sol y Luna'
}) => {
  React.useEffect(() => {
    // Actualizar título
    document.title = title;
    
    // Meta description
    let metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) metaDescription.content = description;
    
    // Keywords
    let metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) metaKeywords.content = keywords;
    
    // Author
    let metaAuthor = document.querySelector('meta[name="author"]');
    if (metaAuthor) metaAuthor.content = author;
    
    // Canonical
    let canonicalLink = document.querySelector('link[rel="canonical"]');
    if (canonicalLink) {
      canonicalLink.href = canonical;
    } else {
      canonicalLink = document.createElement('link');
      canonicalLink.rel = 'canonical';
      canonicalLink.href = canonical;
      document.head.appendChild(canonicalLink);
    }
    
    // Open Graph
    updateOrCreateMetaTag('property', 'og:title', title);
    updateOrCreateMetaTag('property', 'og:description', description);
    updateOrCreateMetaTag('property', 'og:type', ogType);
    updateOrCreateMetaTag('property', 'og:url', canonical);
    updateOrCreateMetaTag('property', 'og:image', ogImage);
    
    // Twitter Card
    updateOrCreateMetaTag('name', 'twitter:title', title);
    updateOrCreateMetaTag('name', 'twitter:description', description);
    updateOrCreateMetaTag('name', 'twitter:image', ogImage);
    
  }, [title, description, keywords, canonical, ogImage, ogType, author]);
  
  return null;
};

/**
 * Función auxiliar para actualizar o crear meta tags
 */
const updateOrCreateMetaTag = (attrName, attrValue, content) => {
  let meta = document.querySelector(`meta[${attrName}="${attrValue}"]`);
  if (meta) {
    meta.content = content;
  } else {
    meta = document.createElement('meta');
    meta.setAttribute(attrName, attrValue);
    meta.content = content;
    document.head.appendChild(meta);
  }
};

export default SEOHead;
